var WcagMenu = {
	register: function() {
	},

	init: function() {
		WcagMenu.node = $("<div id='wcagui_container'><div class='top-nav'><a class='btn btn-menu' id='wcag-menu-btn' href='javascript:void(null);'><i class='fas fa-bars'></i> Menu</a></div><div id='wcag-menu'></div></div>");
		$("#panels").append(WcagMenu.node);
		AppEvent.on(player, "PLACE.LOADED", WcagMenu.placeLoaded);

		WcagMenu.node.find("#wcag-menu-btn").on("click", WcagMenu.openMenu);
	},

	show: function() {
		$("#menu_container").hide();
		$("#wcagui_container").show();
	},

	openMenu: function() {
		WcagMenu.node.find("#wcag-menu").addClass("expand");
	},

	slideMenu: function(min, mout) {
		$("#" + min).addClass("in");
		$("#" + mout).addClass("out");
	},

	backMenu: function(back, out) {
		$("#" + back).removeClass("out");
		$("#" + out).removeClass("in");
	},

	placeMenu: function(id, parent, items) {
		var menu = $("<div class='menunav' id='" + id + "'></div>");
		var subs = [];

		if (parent != null) {
			var mitem = $("<a class='item' href='javascript:void(null)'>&laquo; Cofnij</a>");
			menu.append(mitem);
			mitem.on("click", function() {
				WcagMenu.backMenu(parent, id);
			});
		}

		for(var n in items) {
			var m = items[n];
			var mitem = $("<a class='item' data-mnu='" + id + "-" + n + "' href='javascript:void(null)'>" + m.title + "</a>");
			menu.append(mitem);

			if (m.childs != undefined) {
				subs.push(WcagMenu.placeMenu(id + "-" + n, id, m.childs));

				mitem.html(m.title + " >");

				mitem.on("click", function() {
					WcagMenu.slideMenu($(this).data("mnu"), id);
				});
			}
		}

		if (subs.length > 0) subs.splice(0,0,menu);
		else subs.push(menu);

		return subs;
	},

	placeLoaded: function() {		
		var data = Menu.placedata;

		var node = WcagMenu.node.find("#wcag-menu");
		node.html("");

		var mnodes = WcagMenu.placeMenu('nav-root', null, data.menu);

		for(var mn in mnodes)
			node.append(mnodes[mn]);

		mnodes[0].addClass("in");
	}
}

PluginManager.add(WcagMenu);